export const CAROUSEL_VERSION_1 = '1';
export const CAROUSEL_VERSION_2 = '2';
